// extracted by mini-css-extract-plugin
export default {"tudContainerMobile":"TrialUpgradeDisclaimer_tudContainerMobile__Iu2NL","tudContainerDesktop":"TrialUpgradeDisclaimer_tudContainerDesktop__kwTS+"};